/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';

import router from '@/router/index';

// import {comparePosition, extractErrorDetails} from '@/helpers/util.js';
import {isNewValueDeciding} from '@/helpers/util.js';

const initialState = () => ({
  new_pmilestone: {
    token: '',
    name: '',
    date: '',
    status: 'none',
    offset: 0,
    offset_type: 'days',
    chronology: 'after',
  },
  new_milestone: {
    token: '',
    name: '',
    status: 'none',
    offset: 0,
    offset_type: 'days',
    chronology: 'after',
    linkType: 'selection',
    trains: [],
    taktareas: [],
    work_packages: [],
    tworkpackages: [],
    wp_color: false,
    wp_color_active: false,
    wp_icon: false,
    wp_icon_active: false,
    wp_name: false,
    wp_name_active: false,
    wp_token: false,
    wp_token_active: false,
  },
  error: '',
});

// State object
const state = initialState();
// Getter functions
const getters = {
  //Getters to UltraStore state
  getElementsIndexAndLocation: (state, getters, rootState) => (payload) => {
    let element = {};
    let waggon_index = 0;
    let taktarea_start = 0;
    let train_start = 0;
    element[`${payload.type}_id`] = payload.id;
    if (['tworkpackage'].includes(payload.type)) {
      element.waggon_id = parseInt(Object.entries(rootState.Ultra.twaggons).filter(waggon => waggon[1].tworkpackages.includes(parseInt(element.tworkpackage_id)))[0][0]);
    }
    if (['waggon', 'tworkpackage'].includes(payload.type)) {
      let taktarea = Object.entries(rootState.Ultra.taktareas).filter(taktarea => taktarea[1].twaggons.includes(parseInt(element.waggon_id)));
      element.taktarea_id = parseInt(taktarea[0][0]);
      waggon_index = taktarea[0][1].twaggons.indexOf(element.waggon_id);
    }
    if (['taktarea', 'waggon', 'tworkpackage'].includes(payload.type)) {
      let train = Object.entries(rootState.Ultra.trains).filter(train => train[1].taktareas.includes(parseInt(element.taktarea_id)));
      element.train_id = parseInt(train[0][0]);
      taktarea_start = rootState.Ultra.taktareas[element.taktarea_id].taktarea_start;
    }
    if (['train', 'taktarea', 'waggon', 'tworkpackage'].includes(payload.type)) {
      train_start = rootState.Ultra.trains[element.train_id].train_start;
      element.index = waggon_index + taktarea_start + train_start;
    }
    return element;
  },
  getPMileStones: (state, getters, rootState, rootGetters) => (project_id) => {
    let pmilestones = [];
    let takt_index_identifiers = [];
    for (let i = 0; i < rootState.Ultra.projects[project_id].pmilestones.length; i++) {
      let milestone_id = rootState.Ultra.projects[project_id].pmilestones[i];
      let pmilestone = rootGetters['Ultra/getUObject']({ type: 'milestones', id: milestone_id });
      let takt_index = rootGetters['ProjectCalendar/getTaktIndexFromDate']({
        project_id: project_id,
        date_string: pmilestone.date.substring(0, 10)
      });
      let takt_index_identifier = takt_index.index + takt_index.position / (takt_index.takt_length + 1);
      let offset_y = takt_index_identifiers.filter(entry => entry === takt_index_identifier).length;
      pmilestones.push({
        takt_index_identifier: takt_index_identifier,
        offset_y: offset_y,
        takt_index: takt_index,
        pmilestone: pmilestone,
      });
      takt_index_identifiers.push(takt_index_identifier);
    }
    for (let i = 0; i < pmilestones.length; i++) {
      let pmilestone = pmilestones[i];
      let takt_index_identifier = pmilestone.takt_index.index + pmilestone.takt_index.position / (pmilestone.takt_index.takt_length + 1);
      let distance_min = 0;
      if (takt_index_identifiers.filter(entry => entry === takt_index_identifier).length === 1) {
        let distances = [];
        for (let i = 0; i < takt_index_identifiers.length; i++) {
          if (takt_index_identifiers[i] - takt_index_identifier !== 0) {
            distances.push(Math.abs(takt_index_identifiers[i] - takt_index_identifier));
          }
        }
        distance_min = Math.min(...distances);
      }
      pmilestone.distance_min = distance_min;
    }
    //sort by date (index)
    pmilestones.sort(function (a, b) {
      return a.takt_index_identifier - b.takt_index_identifier;
    });
    return pmilestones;
  },
  getMileStones: (state, getters, rootState, rootGetters) => (project_id) => {
    let milestones = [];
    let takt_index_identifiers = [];
    for (let i = 0; i < rootState.Ultra.projects[project_id].milestones.length; i++) {
      let decisive_entity = {
        type: '',
        id: -1,
        value: -1,
      };

      let milestone_id = rootState.Ultra.projects[project_id].milestones[i];
      let milestone = rootGetters['Ultra/getUObject']({ type: 'milestones', id: milestone_id });

      let takt_indices = [];
      let trains = [];
      let selection = [];
      let takt_index = {
        index: -1,
        position: 0,
        takt_length: 1,
      };
      let date = rootGetters['ProjectCalendar/getCalendar'](project_id).takt_times[0].dates[0];
      if (milestone.linkType === 'selection') {
        //Workpackages
        for (let i = 0; i < milestone.tworkpackages.length; i++) {
          let index_location = getters.getElementsIndexAndLocation({
            id: milestone.tworkpackages[i],
            type: 'tworkpackage'
          });
          //min
          takt_indices.push(index_location.index);
          //max
          takt_indices.push(index_location.index + 1);

          let newDicidingValue = index_location.index;
          if (milestone.chronology === 'after') {
            newDicidingValue = index_location.index + 1;
          }

          if (isNewValueDeciding(decisive_entity, milestone.chronology, newDicidingValue)) {
            decisive_entity.type = 'work_package';
            decisive_entity.id = milestone.work_packages[i];
            decisive_entity.value = newDicidingValue;
          }

          trains.push(index_location.train_id);
          if (selection.findIndex(train => train.id === index_location.train_id) === -1) {
            selection.push({
              id: index_location.train_id,
              selected: false,
              taktareas: [{
                id: index_location.taktarea_id,
                selected: false,
                work_packages: [{
                  id: milestone.tworkpackages[i],
                  waggon_id: index_location.waggon_id,
                  selected: true,
                }]
              }]
            });
          }
          else if (selection.find(train => train.id === index_location.train_id).taktareas.findIndex(taktarea => taktarea.id === index_location.taktarea_id) === -1) {
            selection.find(train => train.id === index_location.train_id)
            .taktareas.push({
              id: index_location.taktarea_id,
              selected: false,
              work_packages: [{
                id: milestone.tworkpackages[i],
                selected: true,
              }]
            });
          }
          else {
            selection.find(train => train.id === index_location.train_id)
            .taktareas.find(taktarea => taktarea.id === index_location.taktarea_id)
            .work_packages.push({
              id: milestone.tworkpackages[i],
              selected: true,
            });
          }
        }
        //Taktareas
        for (let i = 0; i < milestone.taktareas.length; i++) {
          let index_location = getters.getElementsIndexAndLocation({
            id: milestone.taktareas[i],
            type: 'taktarea'
          });
          //min
          takt_indices.push(index_location.index);
          //max
          takt_indices.push(index_location.index + rootGetters['TaktArea/getTaktarea'](milestone.taktareas[i]).twaggons.length);

          let newDicidingValue = index_location.index;
          if (milestone.chronology === 'after') {
            newDicidingValue = index_location.index + rootGetters['TaktArea/getTaktarea'](milestone.taktareas[i]).twaggons.length;
          }

          if (isNewValueDeciding(decisive_entity, milestone.chronology, newDicidingValue)) {
            decisive_entity.type = 'taktarea';
            decisive_entity.id = milestone.taktareas[i];
            decisive_entity.value = newDicidingValue;
          }

          trains.push(index_location.train_id);
          if (selection.findIndex(train => train.id === index_location.train_id) === -1) {
            selection.push({
              id: index_location.train_id,
              selected: false,
              taktareas: [{
                id: index_location.taktarea_id,
                selected: true,
                work_packages: [],
              }]
            });
          }
          else if (selection.find(train => train.id === index_location.train_id).taktareas.findIndex(taktarea => taktarea.id === index_location.taktarea_id) === -1) {
            selection.find(train => train.id === index_location.train_id)
            .taktareas.push({
              id: index_location.taktarea_id,
              selected: true,
              work_packages: [],
            });
          } else {
            selection.find(train => train.id === index_location.train_id)
            .taktareas.find(taktarea => taktarea.id === index_location.taktarea_id)
            .selected = true;
          }
        }
        //Trains
        for (let i = 0; i < milestone.trains.length; i++) {
          let index_location = getters.getElementsIndexAndLocation({
            id: milestone.trains[i],
            type: 'train'
          });
          //min
          takt_indices.push(index_location.index);
          //max
          takt_indices.push(rootGetters['Train/getTrainLength'](milestone.trains[i]));

          let newDicidingValue = index_location.index;
          if (milestone.chronology === 'after') {
            newDicidingValue = rootGetters['Train/getTrainLength'](milestone.trains[i]);
          }

          if (isNewValueDeciding(decisive_entity, milestone.chronology, newDicidingValue)) {
            decisive_entity.type = 'train';
            decisive_entity.id = milestone.trains[i];
            decisive_entity.value = newDicidingValue;
          }

          trains.push(index_location.train_id);
          if (selection.findIndex(train => train.id === index_location.train_id) === -1) {
            selection.push({
              id: index_location.train_id,
              selected: true,
              taktareas: []
            });
          } else {
            selection.find(train => train.id === index_location.train_id).selected = true;
          }
        }
      } else {
        let filter = {};
        if (milestone.wp_color_active && milestone.wp_color) {
          filter.color = milestone.wp_color;
        }
        if (milestone.wp_token_active && milestone.wp_token) {
          filter.token = milestone.wp_token;
        }
        if (milestone.wp_icon_active && milestone.wp_icon) {
          filter.icon = milestone.wp_icon;
        }
        if (milestone.wp_name_active && milestone.wp_name) {
          filter.name = milestone.wp_name;
        }
        //Workpackages
        let work_packages = [];
        if (Object.entries(filter).length !== 0) {
          work_packages = rootGetters['Train/getTWorkPackagesFiltered']({
            project_id: project_id,
            trains: [],
            filter: filter
          });
        }
        for (let i = 0; i < work_packages.length; i++) {
          let index_location = getters.getElementsIndexAndLocation({
            id: work_packages[i].id,
            type: 'tworkpackage'
          });
          //min
          takt_indices.push(index_location.index);
          //max
          takt_indices.push(index_location.index + 1);
          trains.push(index_location.train_id);
        }
      }
      //create Milestone location
      if (takt_indices.length !== 0) {
      if (milestone.chronology === 'before') {
        takt_index.index = Math.max(0, Math.min(...takt_indices) - milestone.offset);
      } else {
        takt_index.index = Math.min(rootGetters['ProjectCalendar/getCalendar'](project_id).takt_times.length, Math.max(...takt_indices) + parseInt(milestone.offset));
      }
      date = rootGetters['ProjectCalendar/getDateFromTaktIndex']({
            project_id: project_id,
            takt_index: takt_index.index,
            chronology: milestone.chronology
          });
      }
      let takt_index_identifier = takt_index.index + takt_index.position / (takt_index.takt_length + 1);
      let offset_y = takt_index_identifiers.filter(entry => entry === takt_index_identifier).length;
      milestones.push({
        calculated_date: date,
        offset_y: offset_y,
        takt_index: takt_index,
        milestone: milestone,
        trains: trains,
        selection: selection,
        decisive_entity: decisive_entity
      });
      // TODO: reset decisive_entity
      takt_index_identifiers.push(takt_index_identifier);
    }
    for (let i = 0; i < milestones.length; i++) {
      let milestone = milestones[i];
      let takt_index_identifier = milestone.takt_index.index + milestone.takt_index.position / (milestone.takt_index.takt_length + 1);
      let distance_min = 0;
      if (takt_index_identifiers.filter(entry => entry === takt_index_identifier).length === 1) {
        let distances = [];
        for (let i = 0; i < takt_index_identifiers.length; i++) {
          if (takt_index_identifiers[i] - takt_index_identifier !== 0) {
            distances.push(Math.abs(takt_index_identifiers[i] - takt_index_identifier));
          }
        }
        distance_min = Math.min(...distances);
      }
      milestone.distance_min = distance_min;
    }
    //sort by date (index)
    milestones.sort(function (a, b) {
      return a.calculated_date.getTime() - b.calculated_date.getTime();
    });
    return milestones;
  },
  getMileStoneLinkType: (state, getters, rootState) => payload => {
    return rootState.Ultra.milestones[payload.milestone_id].linkType;
  },
  getMileStoneSelection: (state, getters, rootState, rootGetters) => (payload) => {
    let selection = {
      trains: [],
      taktareas: [],
      tworkpackages: [],
    };
    if (payload.milestone_id) {
      // let milestone_id = rootState.Ultra.projects[payload.project_id].milestones.find(milestone => milestone === payload.milestone_id);
      let milestone = rootGetters['Ultra/getUObject']({ type: 'milestones', id: payload.milestone_id });
      if (milestone.linkType === 'selection') {
        selection.trains = milestone.trains;
        selection.taktareas = milestone.taktareas;
        selection.tworkpackages = milestone.tworkpackages;
      } else {
        let filter = {};
        if (milestone.wp_color_active && milestone.wp_color) {
          filter.color = milestone.wp_color;
        }
        if (milestone.wp_token_active && milestone.wp_token) {
          filter.token = milestone.wp_token;
        }
        if (milestone.wp_icon_active && milestone.wp_icon) {
          filter.icon = milestone.wp_icon;
        }
        if (milestone.wp_name_active && milestone.wp_name) {
          filter.name = milestone.wp_name;
        }
        if (Object.entries(filter).length !== 0) {
          let work_packages = rootGetters['Train/getTWorkPackagesFiltered']({
            project_id: payload.project_id,
            trains: [],
            filter: filter
          });
          for (var i = 0; i < work_packages.length; i++) {
            selection.tworkpackages.push(work_packages[i].id);
          }
        }
      }
    }
    return selection;
  },
  //helpers
  getNewPMilestone: (state, getters, rootState, rootGetters) => (project_id) => {
    let pmilestone = state.new_pmilestone;
    let takt_index = rootGetters['ProjectCalendar/getTaktIndexFromDate']({
      project_id: project_id,
      date_string: pmilestone.date.substring(0, 10)
    });
    return {
      takt_index: takt_index,
      pmilestone: pmilestone,
    };
  },
  getNewMilestoneForPayload: (state, getters) => (project_id) => {
    let result = getters.getNewMilestone(project_id);
    let milestone = result.milestone;
    milestone['add#trains'] = [];
    milestone['add#taktareas'] = [];
    milestone['add#tworkpackages'] = [];

    // trains for loop
    for (let i = 0; i < result.selection.length; i++) {
      if (result.selection[i].selected) {
        milestone['add#trains'].push(result.selection[i].id);
      }
      // taktareas for loop
      for (let j = 0; j < result.selection[i].taktareas.length; j++) {
        if (result.selection[i].taktareas[j].selected) {
          milestone['add#taktareas'].push(result.selection[i].taktareas[j].id);
        }
        // work_packages for loop
        for (let k = 0; k < result.selection[i].taktareas[j].work_packages.length; k++) {
          if (result.selection[i].taktareas[j].work_packages[k].selected) {
            milestone['add#tworkpackages'].push(result.selection[i].taktareas[j].work_packages[k].id);
          }

        } // end of work_packages loop
      } // end of taktareas loop
    } // end of trains loop

    return milestone;

  },
  getNewMilestone: (state, getters, rootState, rootGetters) => (project_id) => {
    let milestone = state.new_milestone;
    let takt_indices = [];
    let trains = [];
    let selection = [];
    let takt_index = {
      index: -1,
      position: 0,
      takt_length: 1,
    };
    let decisive_entity = {
      type: '',
      id: -1,
      value: -1,
    };
    let date = false;
    //Linktype Selection
    if (milestone.linkType === 'selection') {
      //Workpackages
      for (let i = 0; i < milestone.tworkpackages.length; i++) {
        let index_location = getters.getElementsIndexAndLocation({
          id: milestone.tworkpackages[i],
          type: 'tworkpackage'
        });
        //min
        takt_indices.push(index_location.index);
        //max
        takt_indices.push(index_location.index + 1);

        let newDicidingValue = index_location.index;
        if (milestone.chronology === 'after') {
          newDicidingValue = index_location.index + 1;
        }

        if (isNewValueDeciding(decisive_entity, milestone.chronology, newDicidingValue)) {
          decisive_entity.type = 'work_package';
          decisive_entity.id = milestone.work_packages[i];
          decisive_entity.value = newDicidingValue;
        }

        trains.push(index_location.train_id);
        if (selection.findIndex(train => train.id === index_location.train_id) === -1) {
          selection.push({
            id: index_location.train_id,
            selected: false,
            taktareas: [{
              id: index_location.taktarea_id,
              selected: false,
              work_packages: [{
                id: milestone.tworkpackages[i],
                selected: true,
              }]
            }]
          });
        }
        else if (selection.find(train => train.id === index_location.train_id).taktareas.findIndex(taktarea => taktarea.id === index_location.taktarea_id) === -1) {
          selection.find(train => train.id === index_location.train_id)
          .taktareas.push({
            id: index_location.taktarea_id,
            selected: false,
            work_packages: [{
              id: milestone.tworkpackages[i],
              selected: true,
            }]
          });
        }
        else {
          selection.find(train => train.id === index_location.train_id)
          .taktareas.find(taktarea => taktarea.id === index_location.taktarea_id)
          .work_packages.push({
            id: milestone.tworkpackages[i],
            selected: true,
          });
        }
      }
      //Taktareas
      for (let i = 0; i < milestone.taktareas.length; i++) {
        let index_location = getters.getElementsIndexAndLocation({
          id: milestone.taktareas[i],
          type: 'taktarea'
        });
        //min
        takt_indices.push(index_location.index);
        //max
        takt_indices.push(index_location.index + rootGetters['TaktArea/getTaktarea'](milestone.taktareas[i]).twaggons.length);

        let newDicidingValue = index_location.index;
        if (milestone.chronology === 'after') {
          newDicidingValue = index_location.index + rootGetters['TaktArea/getTaktarea'](milestone.taktareas[i]).twaggons.length;
        }

        if (isNewValueDeciding(decisive_entity, milestone.chronology, newDicidingValue)) {
          decisive_entity.type = 'taktarea';
          decisive_entity.id = milestone.taktareas[i];
          decisive_entity.value = newDicidingValue;
        }

        trains.push(index_location.train_id);
        if (selection.findIndex(train => train.id === index_location.train_id) === -1) {
          selection.push({
            id: index_location.train_id,
            selected: false,
            taktareas: [{
              id: index_location.taktarea_id,
              selected: true,
              work_packages: [],
            }]
          });
        }
        else if (selection.find(train => train.id === index_location.train_id).taktareas.indexOf(taktarea => taktarea.id === index_location.taktarea_id) === -1) {
          selection.find(train => train.id === index_location.train_id)
          .taktareas.push({
            id: index_location.taktarea_id,
            selected: true,
            work_packages: [],
          });
        } else {
          selection.find(train => train.id === index_location.train_id)
          .taktareas.find(taktarea => taktarea.id === index_location.taktarea_id)
          .selected = true;
        }
      }
      //Trains
      for (let i = 0; i < milestone.trains.length; i++) {
        let index_location = getters.getElementsIndexAndLocation({
          id: milestone.trains[i],
          type: 'train'
        });
        //min
        takt_indices.push(index_location.index);
        //max
        takt_indices.push(rootGetters['Train/getTrainLength'](milestone.trains[i]));

        let newDicidingValue = index_location.index;
        if (milestone.chronology === 'after') {
          newDicidingValue = rootGetters['Train/getTrainLength'](milestone.trains[i]);
        }

        if (isNewValueDeciding(decisive_entity, milestone.chronology, newDicidingValue)) {
          decisive_entity.type = 'train';
          decisive_entity.id = milestone.trains[i];
          decisive_entity.value = newDicidingValue;
        }

        trains.push(index_location.train_id);
        if (selection.findIndex(train => train.id === index_location.train_id) === -1) {
          selection.push({
            id: index_location.train_id,
            selected: true,
            taktareas: []
          });
        } else {
          selection.find(train => train.id === index_location.train_id).selected = true;
        }
      }
    } else {
      let filter = {};
      if (milestone.wp_color_active && milestone.wp_color) {
        filter.color = milestone.wp_color;
      }
      if (milestone.wp_token_active && milestone.wp_token) {
        filter.token = milestone.wp_token;
      }
      if (milestone.wp_icon_active && milestone.wp_icon) {
        filter.icon = milestone.wp_icon;
      }
      if (milestone.wp_name_active && milestone.wp_name) {
        filter.name = milestone.wp_name;
      }
      //Workpackages
      let work_packages = [];
      if (Object.entries(filter).length !== 0) {
        work_packages = rootGetters['Train/getTWorkPackagesFiltered']({
          project_id: project_id,
          trains: [],
          filter: filter
        });
      }
      for (let i = 0; i < work_packages.length; i++) {
        let index_location = getters.getElementsIndexAndLocation({
          id: work_packages[i].id,
          type: 'tworkpackage'
        });
        //min
        takt_indices.push(index_location.index);
        //max
        takt_indices.push(index_location.index + 1);
        trains.push(index_location.train_id);
      }
    }
    //create Milestone location
    if (takt_indices.length !== 0) {
      if (milestone.chronology === 'before') {
        takt_index.index = Math.max(0, Math.min(...takt_indices) - milestone.offset);
      } else {
        takt_index.index = Math.min(rootGetters['ProjectCalendar/getCalendar'](project_id).takt_times.length, Math.max(...takt_indices) + parseInt(milestone.offset));
      }
      date = rootGetters['ProjectCalendar/getDateFromTaktIndex']({
        project_id: project_id,
        takt_index: takt_index.index,
        chronology: milestone.chronology
      });
    }
    return {
      calculated_date: date,
      // offset_y: offset_y,
      takt_index: takt_index,
      milestone: milestone,
      trains: trains,
      selection: selection,
      decisive_entity: decisive_entity
    };
  },
  getLinkedTMilestones: (state, getters, rootState) => (payload) => {
    let linkedMilestones = [];
    rootState.Ultra.projects[payload.project_id].milestones.forEach((milestone_id) => {
      if (rootState.Ultra.milestones[milestone_id].tworkpackages.includes(payload.workpackage_id)){
        linkedMilestones.push(milestone_id);
      }
    });
    return linkedMilestones;
  },
  getLinkedPMilestones: (state, getters, rootState) => (payload) => {
    let linkedMilestones = [];
    rootState.Ultra.projects[payload.project_id].pmilestones.forEach((pmilestone_id) => {
      if (rootState.Ultra.milestones[pmilestone_id].aremilestones.includes(payload.tmilestone_id)){
        linkedMilestones.push(pmilestone_id);
      }
    });
    return linkedMilestones;
  },
  //payload: milestone_id, project_id
  getTrainMilestoneStatus: (state, getters, rootState, rootGetters) => (payload) => {
  let milestone = rootState.Ultra.milestones[payload.milestone_id];
  let status = 'done';
  let status_array = ['none', 'ready', 'started', 'done', 'checked', 'closed'];
  // hier 'done' auf individuellen Status milestone.check_status
  // console.log(milestone);
  let check_index = status_array.indexOf(milestone.check_status);
  if (milestone.linkType == 'type') {
    let filter = {};
    if (milestone.wp_color_active && milestone.wp_color) {
      filter.color = milestone.wp_color;
    }
    if (milestone.wp_token_active && milestone.wp_token) {
      filter.token = milestone.wp_token;
    }
    if (milestone.wp_icon_active && milestone.wp_icon) {
      filter.icon = milestone.wp_icon;
    }
    if (milestone.wp_name_active && milestone.wp_name) {
      filter.name = milestone.wp_name;
    }
    let work_packages = [];
    if (Object.entries(filter).length !== 0) {
      work_packages = rootGetters['Train/getTWorkPackagesFiltered']({
        project_id: payload.project_id,
        trains: [],
        filter: filter
      });
    }
    for (var i = 0; i < work_packages.length; i++) {
      if (work_packages[i].stop_status != 'none') {
        return 'stop';
      }
      else if (status_array.indexOf(work_packages[i].status) < check_index) {
        status = 'none';
      }
    }
  }
  else {
    for (let i = 0; i < milestone.trains.length; i++) {
      let train = rootState.Ultra.trains[milestone.trains[i]];
      for (let j = 0; j < train.taktareas.length; j++) {
        let taktarea = rootState.Ultra.taktareas[train.taktareas[j]];
        for (let k = 0; k < taktarea.twaggons.length; k++) {
          let twaggon = rootState.Ultra.twaggons[taktarea.twaggons[k]];
          for (let l = 0; l < twaggon.tworkpackages.length; l++) {
            let tworkpackage = rootState.Ultra.tworkpackages[twaggon.tworkpackages[l]];
            if (tworkpackage.stop_status != 'none') {
              return 'stop';
            }
            else if (status_array.indexOf(tworkpackage.status) < check_index) {
              status = 'none';
            }
          }
        }
      }
    }
    for (let j = 0; j < milestone.taktareas.length; j++) {
      let taktarea = rootState.Ultra.taktareas[milestone.taktareas[j]];
      for (let k = 0; k < taktarea.twaggons.length; k++) {
        let twaggon = rootState.Ultra.twaggons[taktarea.twaggons[k]];
        for (let l = 0; l < twaggon.tworkpackages.length; l++) {
          let tworkpackage = rootState.Ultra.tworkpackages[twaggon.tworkpackages[l]];
          if (tworkpackage.stop_status != 'none') {
            return 'stop';
          }
          else if (status_array.indexOf(tworkpackage.status) < check_index) {
            status = 'none';
          }
        }
      }
    }
    for (let l = 0; l < milestone.tworkpackages.length; l++) {
      let tworkpackage = rootState.Ultra.tworkpackages[milestone.tworkpackages[l]];
      if (tworkpackage.stop_status != 'none') {
        return 'stop';
      }
      else if (status_array.indexOf(tworkpackage.status) < check_index) {
        status = 'none';
      }
    }
  }
  return status;
},
//payload: milestone_id as id, takt_index, project_id
getProjectMilestoneStatus: (state, getters, rootState) => (payload) => {
  let milestone = rootState.Ultra.milestones[payload.id];
  if(milestone.aremilestones.length === 0) {
    return milestone.status;
  } else {
    let status = 'done';
    let milestone_takt = payload.takt_index;
    for (var i = 0; i < milestone.aremilestones.length; i++) {
      let aremilestone_takt = getters.getMilestoneTakt({
        project_id: payload.project_id,
        milestone_id: milestone.aremilestones[i]
      });
      if (
        getters.getTrainMilestoneStatus({
          milestone_id: milestone.aremilestones[i],
          project_id: payload.project_id}) === 'stop' ||
        milestone_takt.index < aremilestone_takt.index
      ){
        return 'stop';
      } else if (getters.getTrainMilestoneStatus({
        milestone_id: milestone.aremilestones[i],
        project_id: payload.project_id}) === 'none'){
        status = 'none';
      }
    }
    return status;
  }
},
getMilestoneTakt: (state, getters, rootState, rootGetters) => (payload) => {
  let milestone = rootGetters['Ultra/getUObject']({ type: 'milestones', id: payload.milestone_id });
  let takt_indices = [];
  let takt_index = {
    index: -1,
    position: 0,
    takt_length: 1,
  };
  if (milestone.linkType === 'selection') {
    //Workpackages
    for (let i = 0; i < milestone.tworkpackages.length; i++) {
      let index_location = getters.getElementsIndexAndLocation({
        id: milestone.tworkpackages[i],
        type: 'tworkpackage'
      });
      //min
      takt_indices.push(index_location.index);
      //max
      takt_indices.push(index_location.index + 1);
    }
    //Taktareas
    for (let i = 0; i < milestone.taktareas.length; i++) {
      let index_location = getters.getElementsIndexAndLocation({
        id: milestone.taktareas[i],
        type: 'taktarea'
      });
      //min
      takt_indices.push(index_location.index);
      //max
      takt_indices.push(index_location.index + rootGetters['TaktArea/getTaktarea'](milestone.taktareas[i]).twaggons.length);

    }
    //Trains
    for (let i = 0; i < milestone.trains.length; i++) {
      let index_location = getters.getElementsIndexAndLocation({
        id: milestone.trains[i],
        type: 'train'
      });
      //min
      takt_indices.push(index_location.index);
      //max
      takt_indices.push(rootGetters['Train/getTrainLength'](milestone.trains[i]));

    }
  } else {
    let filter = {};
    if (milestone.wp_color_active && milestone.wp_color) {
      filter.color = milestone.wp_color;
    }
    if (milestone.wp_token_active && milestone.wp_token) {
      filter.token = milestone.wp_token;
    }
    if (milestone.wp_icon_active && milestone.wp_icon) {
      filter.icon = milestone.wp_icon;
    }
    if (milestone.wp_name_active && milestone.wp_name) {
      filter.name = milestone.wp_name;
    }
    //Workpackages
    let work_packages = [];
    if (Object.entries(filter).length !== 0) {
      work_packages = rootGetters['Train/getTWorkPackagesFiltered']({
        project_id: payload.project_id,
        trains: [],
        filter: filter
      });
    }
    for (let i = 0; i < work_packages.length; i++) {
      let index_location = getters.getElementsIndexAndLocation({
        id: work_packages[i].id,
        type: 'tworkpackage'
      });
      //min
      takt_indices.push(index_location.index);
      //max
      takt_indices.push(index_location.index + 1);
    }
  }
  //create Milestone location
  if (takt_indices.length !== 0) {
  if (milestone.chronology === 'before') {
    takt_index.index = Math.max(0, Math.min(...takt_indices) - milestone.offset);
  } else {
    takt_index.index = Math.min(rootGetters['ProjectCalendar/getCalendar'](payload.project_id).takt_times.length, Math.max(...takt_indices) + parseInt(milestone.offset));
  }
  }
  // milestones.push({
  //   calculated_date: date,
  //   offset_y: offset_y,
  //   takt_index: takt_index,
  //   milestone: milestone,
  //   trains: trains,
  //   selection: selection,
  // });
  // takt_index_identifiers.push(takt_index_identifier);
  return takt_index;
}
};
// Actions
const actions = {
  // with Local mutation mutating ultra store
  createMilestone({commit, dispatch, rootState}, payload) {
    if (payload.milestone_type === 'pmilestones') {
      commit('add_milestone_to_project', {rootState, payload});
      router.push({name: 'ProjectMilestones'});
    } else {
      router.push({name: 'TrainMilestones'});
    }
    dispatch('Ultra/requestUObject', {
      url: [
        {projects: payload.project_id},
        {milestones: payload.milestone_id},
        {showWithEntitiesNormalized: ''}
      ],
      no_cache: true,
    }, {root:true});
  },
  createMilestoneOld({commit, rootGetters, rootState}, payload) {
    let milestone_data = payload.milestone;
    milestone_data.edit_key = rootGetters['Project/getEditKey'];
    axios({
        url: 'projects/' + payload.project_id + '/milestones?show=showWithEntitiesNormalized',
        method: 'POST',
        data: milestone_data,
      })
      .then(resp => {
        payload.resp = resp.data.data;
        commit('create_milestone', {rootState, payload});
        if (payload.type === 'pmilestones') {
          router.push({name: 'ProjectMilestones'});
        } else {
          router.push({name: 'TrainMilestones'});
        }
      });
  },
  updateMilestone({commit, rootGetters, rootState}, payload) {
    axios({
        url: 'projects/' + payload.project_id +
             '/milestones/' + payload.milestone_id,
        method: 'PUT',
        data: {
          [payload.prop]: payload.value,
          edit_key: rootGetters['Project/getEditKey'],
        },
      })
      .then(() => {
        commit('update_milestone', {rootState, payload});
      });
  },
  updateMilestoneBulk({commit, rootGetters, rootState}, payload) {
    let update_data = {};
    update_data.edit_key = rootGetters['Project/getEditKey'];
    for (let i = 0; i < payload.data.length; i++) {
      update_data[payload.data[i].prop] = payload.data[i].value
    }
    axios({
        url: 'projects/' + payload.project_id +
             '/milestones/' + payload.milestone_id,
        method: 'PUT',
        data: update_data,
      })
      .then(() => {
        commit('update_milestone_bulk', {rootState, payload});
      });
  },
  deleteMilestoneFromProject({commit, rootState}, payload) {
    commit('delete_milestone_from_project', {rootState, payload});
    if (payload.milestone_type === 'pmilestones') {
      router.push({name: 'ProjectMilestones'});
    } else {
      router.push({name: 'TrainMilestones'});
    }
  },
  deleteMilestone({commit, rootGetters, rootState}, payload) {
    axios({
        url: 'projects/' + payload.project_id + '/milestones/' + payload.milestone_id,
        method: 'DELETE',
        data: {
          edit_key: rootGetters['Project/getEditKey'],
        }
      })
      .then(() => {
        commit('delete_milestone', {rootState, payload});
        if (payload.type === 'pmilestones') {
          router.push({name: 'ProjectMilestones'});
        } else {
          router.push({name: 'TrainMilestones'});
        }
      });
  },
  editMilestoneSelection({dispatch, rootGetters, rootState}, payload) {
    payload.values = [];
    if (payload.prop === 'tworkpackages' && payload.train.closed) {
      let same_work_packages = rootGetters['Train/getTWorkPackagesFiltered']({
        project_id: payload.project_id,
        trains: [payload.train.id],
        filter: {
          color: payload.value.color,
          token: payload.value.token,
          icon: payload.value.icon,
        }
      });
      for (var i = 0; i < same_work_packages.length; i++) {
        payload.values.push(same_work_packages[i].id);
      }
    } else {
      payload.values.push(payload.value.id);
    }
    if (rootState.Ultra.milestones[payload.milestone_id][payload.prop]
      .indexOf(payload.value.id) === -1) {
        dispatch('Ultra/updateUObjectRelations', {
            url: [
              {projects: payload.project_id},
              {milestones: payload.milestone_id}
            ],
            action: 'add',
            target_type: payload.prop,
            target_ids: payload.values
          }, {root:true});
          // commit('add_milestone_selection', {rootState, payload});
      // axios({
        //   url: 'projects/' + payload.project_id +
        //        '/milestones/' + payload.milestone_id,
        //   method: 'PUT',
        //   data: {
        //     ['add#' + payload.prop]: payload.values,
        //     edit_key: rootGetters['Project/getEditKey'],
        //   },
        // })
        // .then(() => {
        //   commit('add_milestone_selection', {rootState, payload});
        // });
    } else {
      dispatch('Ultra/updateUObjectRelations', {
          url: [
            {projects: payload.project_id},
            {milestones: payload.milestone_id}
          ],
          action: 'remove',
          target_type: payload.prop,
          target_ids: payload.values
        }, {root:true});
        // commit('remove_milestone_selection', {rootState, payload});
      // axios({
      //     url: 'projects/' + payload.project_id +
      //          '/milestones/' + payload.milestone_id,
      //     method: 'PUT',
      //     data: {
      //       [payload.prop]: payload.values,
      //       edit_key: rootGetters['Project/getEditKey'],
      //     },
      //   })
      //   .then(() => {
      //     commit('remove_milestone_selection', {rootState, payload});
      //   });
    }
  },
  //local MileStone variables
  updateNewPMilestone({commit}, payload) {
    commit('update_new_pmilestone', payload);
  },
  resetNewPMilestone({commit}) {
    commit('reset_new_pmilestone');
  },
  editNewMilestoneSelection({commit, rootGetters}, payload) {
    payload.values = [];
    if (payload.prop === 'tworkpackages' && payload.train.closed) {
      let same_work_packages = rootGetters['Train/getTWorkPackagesFiltered']({
        project_id: payload.project_id,
        trains: [payload.train.id],
        filter: {
          color: payload.value.color,
          token: payload.value.token,
          icon: payload.value.icon,
        }
      });
      for (var i = 0; i < same_work_packages.length; i++) {
        // gegenrechnen, id schon vorhanden
        payload.values.push(same_work_packages[i].id)
      }
      // payload.values = Object.assign(payload.values, same_work_packages)
    } else {
      payload.values.push(payload.value.id)
    }
    if (state.new_milestone[payload.prop].indexOf(payload.value.id) === -1) {
      commit('add_new_milestone_selection', payload);
    } else {
      commit('remove_new_milestone_selection', payload);
    }
  },
  updateNewMilestone({commit}, payload) {
    commit('update_new_milestone', payload);
  },
  updateNewMilestoneBulk({commit}, payload) {
    commit('update_new_milestone_bulk', payload);
  },
  resetNewMilestone({commit}) {
    commit('reset_new_milestone');
  },
  updateMilestoneRelation({commit, dispatch, rootGetters}, payload) {
    let pM = rootGetters['Ultra/getUObject']({ type: 'milestones', id: payload.pM_id });
    let index = pM.aremilestones.indexOf(payload.tM_id);
    if (index === -1) {
      dispatch('Ultra/updateUObjectRelations', {
          url: [
            {projects: payload.project_id},
            {milestones: payload.pM_id}
          ],
          action: 'add',
          target_type: 'aremilestones',
          target_ids: [payload.tM_id]
        }, {root:true});
        commit('Ultra/update_u_object_relations', {
          url: [
            {projects: payload.project_id},
            {milestones: payload.tM_id}
          ],
          action: 'add',
          target_type: 'shouldmilestones',
          target_ids: [payload.pM_id]
        }, {root: true});
        // commit('add_milestone_relation', payload);
    } else {
      dispatch('Ultra/updateUObjectRelations', {
          url: [
            {projects: payload.project_id},
            {milestones: payload.pM_id}
          ],
          action: 'remove',
          target_type: 'aremilestones',
          target_ids: [payload.tM_id]
        }, {root:true});
        commit('Ultra/update_u_object_relations', {
          url: [
            {projects: payload.project_id},
            {milestones: payload.tM_id}
          ],
          action: 'remove',
          target_type: 'shouldmilestones',
          target_ids: [payload.pM_id]
        }, {root: true});
    }
    dispatch('Ultra/requestUObject', {
      url: [
        {projects: payload.project_id},
        {milestones: payload.pM_id},
        {showWithEntitiesNormalized: ''}
      ],
      no_cache: true,
    }, {root:true});
  },
  //update tmilestone and pmilestone status of tworkpackage
  updateMilestoneStatus({dispatch, getters}, payload) {
    getters.getLinkedTMilestones(payload).forEach((tmilestone_id) => {
      dispatch('Ultra/requestUObject', {
        url: [
          {projects: payload.project_id},
          {milestones: tmilestone_id},
          {showWithEntitiesNormalized: ''}
        ],
        no_cache: true,
      }, {root:true});
      getters.getLinkedPMilestones({project_id: payload.project_id, tmilestone_id: tmilestone_id}).forEach((pmilestone_id) => {
        dispatch('Ultra/requestUObject', {
          url: [
            {projects: payload.project_id},
            {milestones: pmilestone_id},
            {showWithEntitiesNormalized: ''}
          ],
          no_cache: true,
        }, {root:true});
      });
    });

  },
  syncMilestoneStatus({getters, rootGetters}, project_id) {
    let project = rootGetters['Ultra/getUObject']({type: 'projects', id: project_id});
    let milestones = [];
    for (var i = 0; i < project.milestones.length; i++) {
      let milestone_id = project.milestones[i];
      let status = getters.getTrainMilestoneStatus({project_id, milestone_id});
      milestones.push({id: milestone_id, status: status});
    }
    for (var j = 0; j < project.pmilestones.length; j++) {
      let milestone_id = project.pmilestones[j];
      // console.log(getters.getPMileStones(project_id).find(milestone => milestone.pmilestone.id === milestone_id),
      //   getters.getPMileStones(project_id).find(milestone => milestone.pmilestone.id === milestone_id).takt_index);
      let status = getters.getProjectMilestoneStatus({
        project_id,
        id: milestone_id,
        takt_index: getters.getPMileStones(project_id).find(pmilestone => pmilestone.pmilestone.id === milestone_id).takt_index
      });
      milestones.push({id: milestone_id, status: status});
    }
    axios({
        url: 'projects/' + project_id + '/milestones/0/checkmilestones',
        method: 'PUT',
        data: {
          milestones: milestones,
        }
      });
  }
};
// Mutations
const mutations = {
  //ultraStore state mutation
  add_milestone_to_project(state, {rootState, payload}) {
    rootState.Ultra.projects[payload.project_id].pmilestones.push(payload.milestone_id);
    rootState.Ultra.projects[payload.project_id].milestones.splice(rootState.Ultra.projects[payload.project_id].milestones.indexOf(payload.milestone_id));
  },
  create_milestone(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.milestones, payload.resp.id, payload.resp);
    rootState.Ultra.projects[payload.project_id][payload.type].push(payload.resp.id);
  },
  update_milestone(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.project_id][payload.type]
    .find(milestone => milestone.id === payload.milestone_id), `${payload.prop}`, payload.value);
  },
  update_milestone_bulk(state, {rootState, payload}) {
    let milestone = rootState.Ultra.projects[payload.project_id][payload.type]
    .find(milestone => milestone.id === payload.milestone_id);
    for (var i = 0; i < payload.data.length; i++) {
      Vue.set(milestone, `${payload.data[i].prop}`, payload.data[i].value);
    }
  },
  delete_milestone_from_project(state, {rootState, payload}) {
    rootState.Ultra.projects[payload.project_id][payload.milestone_type]
    .splice(rootState.Ultra.projects[payload.project_id][payload.milestone_type]
      .findIndex(milestone_id => milestone_id === payload.milestone_id), 1);
    for (var i = 0; i < payload.are_milestones.length; i++) {
      rootState.Ultra.milestones[payload.are_milestones[i]].shouldmilestones
      .splice(rootState.Ultra.milestones[payload.are_milestones[i]].shouldmilestones
        .indexOf(payload.milestone_id), 1);
    }
    for (var j = 0; j < payload.should_milestones.length; j++) {
      rootState.Ultra.milestones[payload.should_milestones[j]].aremilestones
      .splice(rootState.Ultra.milestones[payload.should_milestones[j]].aremilestones
        .indexOf(payload.milestone_id), 1);
    }
  },
  delete_milestone(state, {rootState, payload}) {
    rootState.Ultra.projects[payload.project_id][payload.type]
    .splice(rootState.Ultra.projects[payload.project_id][payload.type]
      .findIndex(milestone => milestone.id === payload.milestone_id), 1);
  },
  add_milestone_selection(state, {rootState, payload}) {
    for (var i = 0; i < payload.values.length; i++) {
      let prop = rootState.Ultra.milestones[payload.milestone_id][payload.prop];
      if (prop.indexOf(payload.values[i]) === -1) {
        prop.push(payload.values[i])
      }
    }
  },
  remove_milestone_selection(state, {rootState, payload}) {
    for (var i = 0; i < payload.values.length; i++) {
      let prop = rootState.Ultra.milestones[payload.milestone_id][payload.prop];
      let index = prop.indexOf(payload.values[i]);
      prop.splice(index, 1)
    }
  },
  //local state mutation
  update_new_pmilestone(state, payload) {
    state.new_pmilestone[payload.prop] = payload.value;
  },
  reset_new_pmilestone(state) {
    state.new_pmilestone = {
      token: '',
      name: '',
      date: '',
      status: 'none',
      offset: 0,
      offset_type: 'days',
      chronology: 'after',
    };
  },
  add_new_milestone_selection(state, payload) {
    for (var i = 0; i < payload.values.length; i++) {
      let prop = state.new_milestone[payload.prop];
      if (prop.indexOf(payload.values[i]) === -1) {
        prop.push(payload.values[i]);
      }
    }
  },
  remove_new_milestone_selection(state, payload) {
    for (var i = 0; i < payload.values.length; i++) {
      let prop = state.new_milestone[payload.prop];
      let index = prop.indexOf(payload.values[i]);
      prop.splice(index, 1)
    }
  },
  update_new_milestone(state, payload) {
    state.new_milestone[payload.prop] = payload.value;
  },
  update_new_milestone_bulk(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      state.new_milestone[payload[i].prop] = payload[i].value;
    }
  },
  reset_new_milestone(state) {
    state.new_milestone.trains.splice(0, state.new_milestone.trains.length)
    state.new_milestone.taktareas.splice(0, state.new_milestone.taktareas.length)
    state.new_milestone.tworkpackages.splice(0, state.new_milestone.tworkpackages.length)
    let new_milestone = {
      work_packages: [],
      token: '',
      name: '',
      done: false,
      offset: 0,
      offset_type: 'days',
      chronology: 'after',
      linkType: 'selection',
      wp_color: false,
      wp_color_active: false,
      wp_icon: false,
      wp_icon_active: false,
      wp_name: false,
      wp_name_active: false,
      wp_token: false,
      wp_token_active: false,
    };
    state.new_milestone = Object.assign({}, state.new_milestone, new_milestone);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
